"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
var _utils = require("../utils");
var _types = require("../../../types");
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Screen = function Screen(_ref) {
  var children = _ref.children,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    actionLabel = _ref.actionLabel,
    actionDisabled = _ref.actionDisabled,
    _ref$onAction = _ref.onAction,
    onAction = _ref$onAction === void 0 ? _lodash.noop : _ref$onAction;
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    readonly = _useVideoChatCubby.readonly,
    onGoToScreen = _useVideoChatCubby.onGoToScreen,
    screens = _useVideoChatCubby.screens,
    currentScreen = _useVideoChatCubby.currentScreen,
    newNote = _useVideoChatCubby.newNote;
  var screenIndex = screens.indexOf(currentScreen);
  var isLastScreen = screenIndex === screens.length - 1;
  var handleNextScreen = function handleNextScreen() {
    onAction();
    if (isLastScreen) {
      onGoToScreen(_utils.VideoChatCubbyScreen.SectionIndex);
    } else {
      onGoToScreen(screens[screenIndex + 1]);
    }
  };
  var hideAction = readonly || currentScreen === _utils.VideoChatCubbyScreen.Billing && newNote.billingCodeStatus === _types.SessionNoteStatus.Submitted;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-screen-content flex-grow h-0 overflow-auto pb-[8px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pl-[24px] pr-[36px] pt-[20px] flex justify-between items-center"
  }, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    size: "small",
    icon: "caret-left-heavy-16",
    iconPosition: "left",
    onClick: function onClick() {
      return onGoToScreen(_utils.VideoChatCubbyScreen.SectionIndex);
    }
  }, "Back to index")), /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px] py-[12px] flex flex-col divide-x-0 divide-y divide-dashed divide-grey-40"
  }, children))), !hideAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-screen-footer w-full flex flex-col items-center shadow-10 py-[24px]"
  }, currentScreen === _utils.VideoChatCubbyScreen.Billing && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-regular text-black pb-[24px]"
  }, "Once submitted, you will no longer be able to edit these codes"), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    className: "w-[448px]",
    onClick: handleNextScreen,
    disabled: actionDisabled
  }, actionLabel)));
};
exports.Screen = Screen;